import { dataFilm } from 'dls-icons-data'
import { createIcon } from '../common'

const IconFilm = /*#__PURE__*/createIcon(dataFilm)
export default IconFilm
